import script from "./MyMessages.vue?vue&type=script&setup=true&lang=js"
export * from "./MyMessages.vue?vue&type=script&setup=true&lang=js"

import "./MyMessages.vue?vue&type=style&index=0&id=0fc6ce74&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fc6ce74"]])

export default __exports__